import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { Landing } from './routes/landing';
import { Landed } from './routes/landed';
import { Dashboard } from './routes/dashboard';
import { WrapConfig } from './routes/wrap-config';
import { AiCto } from './routes/ai-cto';
import { Costs } from './routes/costs';
import { Audit } from './routes/audit';
import { RequireAuth } from './components/RequireAuth';

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth/landed" element={<Landed />} />
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path="/wrap-config"
          element={
            <RequireAuth>
              <WrapConfig />
            </RequireAuth>
          }
        />
        <Route
          path="/ai-cto"
          element={
            <RequireAuth>
              <AiCto />
            </RequireAuth>
          }
        />
        <Route
          path="/costs"
          element={
            <RequireAuth>
              <Costs />
            </RequireAuth>
          }
        />
        <Route
          path="/audit"
          element={
            <RequireAuth>
              <Audit />
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
